import { TableBody, TableCell } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useAttendance } from '../../../hooks/Features/useAttendance'
import { itemsPerPage } from '../../../shared/data'
import CustomHeading from '../../CustomHeading'
import CustomPagination from '../../CustomPagination'
import Layout from '../../Layout'
import Loader from '../../Loader'
import { NoDataFound } from '../../NoDataFound'
import CustomTable from '../../Table/CustomTable'
import CustomTableHeading from '../../Table/CustomTableHeading'
import CustomTableRow from '../../Table/CustomTableRow'
import styles from '../reports.module.css'
import { SortIcon, FilterIcon } from '../../CustomComponents/CustomFilterIcon'

export default function AttendanceInTimeReport() {
  const { getAttendanceInTimeReport, attendance, loading } = useAttendance()
  const [page, setPage] = React.useState(1)
  const startDate = new Date()
  startDate.setDate(1);
  startDate.setHours(0, 0, 0)
  const [from, setFrom] = useState(startDate.toISOString())
  const [to, setTo] = useState(new Date().toISOString())
  const [filterParams, setFilterParams] = useState({})

  useEffect(() => {
    setPage(1)
    getAttendanceInTimeReport({ from, to, ...filterParams })
  }, [from, to, filterParams])

  const noOfPages = Math.ceil(attendance && attendance.length / itemsPerPage)
  const handleChange = (event, value) => {
    setPage(value)
  }

  const heading = [
    { label: 'Region', key: 'region' },
    { label: 'Zone', key: 'zone' },
    { label: 'State', key: 'state' },
    { label: 'District', key: 'district' },
    { label: 'City', key: 'city' },
    { label: 'Area', key: 'area' },
    { label: 'In Time', key: 'intime' },
  ]

  let tempAttendance = []
  attendance &&
    attendance.forEach((item) =>
      tempAttendance.push({
        region: item.region && item.region.name,
        zone: item.zone && item.zone.name,
        state: item.state && item.state.name,
        district: item.district && item.district.name,
        city: item.city && item.city.name,
        area: item.area && item.area.name,
        intime: (item.inTimePercent + '%'),
      })
    )

  const headingOnClick = {
    'IN TIME (%)': () => {
      setFilterParams({ ...filterParams, inTimePercent: filterParams.inTimePercent === 1 ? -1 : 1 })
    },
  }

  return (
    <Layout heading="In Time Summary Report"
      selectedFrom={from}
      setSelectedFrom={setFrom}
      selectedTo={to}
      setSelectedTo={setTo}
      headers={heading}
      data={tempAttendance ? tempAttendance : []}
      tempHeaderData={[]}
      filename='attendance_inTime_report'
    >
      <CustomTable padding className={styles.table}>
        <CustomTableHeading
          filterIcons={{
            'IN TIME (%)': <SortIcon onClick={headingOnClick['IN TIME (%)']} value={filterParams.inTimePercent} />,
          }}
          heading={['REGION', 'ZONE', 'STATE', 'DISTRICT', 'CITY', 'AREA', 'IN TIME (%)']}
        />
        <TableBody className={styles.tr}>
          {!loading && attendance.length > 0 &&
            attendance.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((item, index) => {
              return (
                <CustomTableRow>
                  <TableCell> {item.region ? item.region.name : '-----'} </TableCell>
                  <TableCell> {item.zone ? item.zone.name : '-----'} </TableCell>
                  <TableCell> {item.state ? item.state.name : '-----'} </TableCell>
                  <TableCell> {item.district ? item.district.name : '-----'} </TableCell>
                  <TableCell> {item.city ? item.city.name : '-----'} </TableCell>
                  <TableCell> {item.area ? item.area.name : '-----'} </TableCell>
                  <TableCell> {item.inTimePercent ? item.inTimePercent.toFixed() + '%' : '0%'} </TableCell>
                </CustomTableRow>
              )
            })
          }
        </TableBody>
      </CustomTable>
      {loading && <Loader />}
      {!loading && attendance.length > 0 && (
        <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />
      )}

      {!loading && attendance.length === 0 && <NoDataFound />}
    </Layout>
  )
}
